export const getSurveyStatus = () => {
  return window.beagly?.status || 'uknonwn';
};
